import React from 'react'
import './LoadingProgressBar.css'

interface LoadingProgressBarProps {
  progress: number // 0-100
  stage: string // Current loading stage description
}

/**
 * Displays loading progress as animated percentage bar during reconstruction loading
 * Shows progress percentage and current stage (e.g., "Loading cameras...", "Building spatial structures...")
 */
export function LoadingProgressBar({ progress, stage }: LoadingProgressBarProps) {
  const displayProgress = Math.min(100, Math.max(0, progress))
  
  return (
    <div className="loading-progress-bar">
      <div className="loading-progress-bar__container">
        {/* Animated progress bar */}
        <div className="loading-progress-bar__track">
          <div 
            className="loading-progress-bar__fill"
            style={{ width: `${displayProgress}%` }}
            aria-valuenow={displayProgress}
            aria-valuemin={0}
            aria-valuemax={100}
            role="progressbar"
          />
        </div>
        
        {/* Progress percentage and stage text */}
        <div className="loading-progress-bar__info">
          <div className="loading-progress-bar__percentage">
            {displayProgress}%
          </div>
          {stage && (
            <div className="loading-progress-bar__stage">
              {stage}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
